const state = {
  codingKey: ''
}

const mutations = {
  'SET_CODINGKEY' (state, key) {
    state.codingKey = key
  }
}

const actions = {
  changeCodingKey: ({commit}, key) => {
    commit('SET_CODINGKEY', key)
  }
}

const getters = {
  currentCodingKey: state => {
    return state.codingKey
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/coding.js